/* global axios */
import ApiClient from './ApiClient';

class PromptTemplatesAPI extends ApiClient {
    constructor() {
        super('prompt_templates', { accountScoped: true });
    }
}

export default new PromptTemplatesAPI();
